import requests from '@/utils/requests'

// 获取扫码链接
export function getsaomalink() {
	return requests({
		url: 'https://wh.lika.net/api/getUrl',
		method: 'POST'
	})
}
// 钉钉获取用户信息是否登陆
export function getuserinfor(data) {
	return requests({
		url: '/api/auth',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
// 钉钉内部登陆
export function loginDingding(data) {
	return requests({
		url: '/api/loginDingding',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
//小助手获取用户信息
export function xzsuserinfor(data) {
	return requests({
		url: '/api/wh/xzs/login',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


// 获取任务列表
export function getTaskData(data) {
	return requests({
		url: '/api/getTask',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取任务详情
export function getTaskDetail(data) {
	return requests({
		url: '/api/getTaskDetails',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取开始任务弹窗中的业务列表
export function getyewuList(data) {
	return requests({
		url: '/api/getTaskDetailsBusiness',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取开始任务弹窗中的通话记录
export function getCallhistory(data) {
	return requests({
		url: '/api/getTaskDetailsCallHistory',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 外呼统计-获取今日数据
export function getTodayData(data) {
	return requests({
		url: '/api/getTodayData',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 外呼统计-获取总体数据
export function getTotalData(data) {
	return requests({
		url: '/api/getHomePageTotal',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



// 呼叫记录-添加通话记录
export function addCallHistory(data) {
	return requests({
		url: '/api/createTaskDetailsCallHistory',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
// 添加通话记录接口
// export function addcallhistory(data) {
// 	return requests({
// 	    url: '/api/createTaskDetailsCallHistory',
// 		headers: {'Content-Type':'multipart/form-data'},
// 	    method: 'POST',
// 		data
// 	})
// }
// 开始任务弹窗-获取录音
export function getTape(data) {
	return requests({
		url: '/call/getvoiceurl',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取首页任务列表统计接口
export function gettasktable(data) {
	return requests({
		url: '/api/getHomePageTotalList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取任务开始执行页面的接口
export function gettaskzhixing(data) {
	return requests({
		url: '/api/getTaskStartList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


// 拨打电话
export function Makingphone(data) {
	return requests({
		url: '/call/makingcall',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}





// 根据ID获取通话记录接口
export function getcallhistoryById(data) {
	return requests({
		url: '/api/getTaskDetailsCallHistoryById',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



// 更新任务进度和状态
export function updateTaskDetailsState(data) {
	return requests({
		url: '/api/updateTaskDetailsState',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


// 根据任务ID获取任务开始头部数据
export function getTaskStartById(data) {
	return requests({
		url: '/api/getTaskStartById',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 根据任务ID获取任务开始头部数据
export function getCustomerInfo(data) {
	return requests({
		url: '/api/getCustomerInfo',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



// 获取商机牛业务类型接口
export function getBusinessType(data) {
	return requests({
		url: '/api/getBusinessType',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


// 创建任务接口
export function createTaskV(data) {
	return requests({
		url: '/api/createTaskV2',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


// 外呼系统录入业务，商机牛接收数据接口
export function EnterCompanyYW(data) {
	return requests({
		url: '/api/EnterCompanyYW',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取弹窗中的所做业务  根据销售商机牛手机号查询该销售可做业务
export function QueryProductByYwyTel(data) {
	return requests({
		url: '/api/QueryProductByYwyTel',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//根据任务ID更新任务数据
export function updateTaskV(data) {
	return requests({
		url: '/api/updateTaskV2',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//外呼统计---本周数据
export function getHomePageWeekTotal(data) {
	return requests({
		url: '/api/getHomePageWeekTotal',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
//外呼统计---本旬数据
export function getHomePageTendayTotal(data) {
	return requests({
		url: '/api/getHomePageTendayTotal',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
//外呼统计---本月数据
export function getHomePageMonthTotal(data) {
	return requests({
		url: '/api/getHomePageMonthTotal',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//获取线路
export function getline() {
	return requests({
		url: '/line/getline',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}


//根据任务ID获取任务数据
export function getTaskById(data) {
	return requests({
		url: '/api/getTaskById',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//商机牛免登录获取用户信息
export function getsjnUserInfor(data) {
	return requests({
		url: '/api/getUserInfo',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



//同步商机牛组织架构
export function getQueryTeamList(data) {
	return requests({
		url: '/api/QueryTeamList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//获取商机牛组织架构
export function GetLocalQueryTeamList(data) {
	return requests({
		url: '/api/GetLocalQueryTeamList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//根据组ID获取组成员
export function QueryStaffByZuid(data) {
	return requests({
		url: '/api/QueryStaffByZuid',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//商机牛获取所有线路
export function getLineList(data) {
	return requests({
		url: '/api/getLineList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
// 设置默认线路
export function setUserLine(data) {
	return requests({
		url: '/api/setUserLine',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
// 设置线路
export function bianjiUserLine(data) {
	return requests({
		url: '/api/setUserLines',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

// 获取商机牛单独拨号通话记录
export function GetAloneCallhistoryList(data) {
	return requests({
		url: '/api/GetAloneCallhistoryList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
//设置线路查询接口
export function getLineUserList(data) {
	return requests({
		url: '/api/getLineUserList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//设置主叫号码
export function setUserCaller(data) {
	return requests({
		url: '/api/setUserCaller',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
//获取过滤列表
export function getFilterList(data) {
	return requests({
		url: '/api/getFilterList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//新增过滤列表
export function addFilter(data) {
	return requests({
		url: '/api/addFilter',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//删除过滤电话
export function deleteFilter(data) {
	return requests({
		url: '/api/deleteFilter',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//外呼任务页面的单独拨号
export function ddmakingcall(data) {
	return requests({
		url: '/onlinecall/makingcall',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//获取是否设置主叫
export function isvercall(data) {
	return requests({
		url: '/call/vercall',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//查询黑名单
export function getheimingdan(data) {
	return requests({
		url: '/api/getFilterByMobile',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}
//关闭外呼功能
export function clearline(data) {
	return requests({
		url: '/call/clearline',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



//获取人员组织信息接口
export function QueryStaffByAdminTel(data) {
	return requests({
		url: '/api/QueryStaffByAdminTel',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



//根据手机号查询通话数据
export function getRecord(data) {
	return requests({
		url: '/api/CallRecord/getRecord',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



//根据手机号批量查询统计数据
export function getRecordList(data) {
	return requests({
		url: '/api/CallRecord/getRecordList',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//超管获取人员列表
export function getUserPage(data) {
	return requests({
		url: '/api/getUserPage',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//超管获取人员列表
export function setAdminById(data) {
	return requests({
		url: '/api/setAdminById',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}



//获取系统配置
export function getSystem(data) {
	return requests({
		url: '/api/getSystem',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//根据权限（领导手机号）查询可查看的团队
export function QueryTeamByAdminTel(data) {
	return requests({
		url: '/api/QueryTeamByAdminTel',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}


//管理员查询各销售的拨打录音情况-----数据统计
export function selectDataStatisticsMultiple(data) {
	return requests({
		url: '/api/Callhistory/selectDataStatisticsMultiple',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}

//根据组ID获取组成员统计记录V2
export function QueryStatisticsByZuid(data) {
	return requests({
		url: '/api/QueryStatisticsByZuid',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'POST',
		data
	})
}




// 通话记录页面获取通话记录
export function v3getRecord(data,datamobi) {
	return requests({
		url: '/api/CallRecord/v3/getRecord?'+data,
		headers: { 'Content-Type': 'application/json' },
		method: 'POST',
		data:datamobi
	})
}

// 获取通话记录上方的数据统计V3
export function v3selectDataStatisticsMultiple(data,datamobi) {
	return requests({
		url: '/api/Callhistory/v3/selectDataStatisticsMultiple?'+data,
		headers: { 'Content-Type': 'application/json' },
		method: 'POST',
		data:datamobi
	})
}

// 通话记录页面导出
export function v3getRecordOfList(data,datamobi) {
	return requests({
		url: '/api/CallRecord/v3/getRecordOfList?'+data,
		headers: { 'Content-Type': 'application/json' },
		method: 'POST',
		data:datamobi
	})
}

// 通话记录页面获取通话记录
export function v3QueryStatisticsByZuid(data) {
	return requests({
		url: '/api/v3/QueryStatisticsByZuid?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}





// 线路分配页面获取数据--分页
export function v3getLineUserList(data) {
	return requests({
		url: '/api/v3/getLineUserList?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}


// 系统获取人员信息
export function v3getUserPage(data) {
	return requests({
		url: '/api/v3/getUserPage?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}


// 线路分配根据组ID获取人员信息接口--分页
export function v3QueryStaffByZuid(data) {
	return requests({
		url: '/api/v3/QueryStaffByZuid?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}

// 同步西湖数据接口---耗时接口需要挂起
export function syncLakeCallRecordList(data) {
	return requests({
		url: '/api/syncLakeCallRecordList?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}


// 获取任务是否正在进行
export function getSync() {
	return requests({
		url: '/api/v3/getSync',
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}

// 同步通话记录
export function UserUpdateRecordData(data) {
	return requests({
		url: '/api/v3/UserUpdateRecordData?openId='+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}


//查看开通人员
export function active(data) {
	return requests({
		url: '/call/active?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}

//人员列表添加线路查询所有 导出功能
export function activeList(data) {
	return requests({
		url: '/call/active/list?'+data,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'GET'
	})
}


//同步吉猫云拨号失败的数据
export function syncJmyRecordid(data) {
	return requests({
		url: '/api/v3/sjn/syncJmyRecordid',
		headers:{ 'Content-Type': 'application/json' },
		method: 'POST',
		data
	})
}







